import { FunctionComponent, useEffect } from 'react'

import Module, {
  AllowedThemes,
  ModuleHeadline,
  ModuleSubheadline,
  themesMap,
} from '@components/undock/modules'
import { Container, Row } from '@components/undock/modules/center/style'
import { CenterModuleI } from '@lib/contentful/entries'
import { ctasMap } from '@components/undock/ctas'

interface CenterModulePropsI extends CenterModuleI {
  themeName: AllowedThemes
}

const CenterModule: FunctionComponent<CenterModulePropsI> = ({
  backgroundImage = null,
  ctaText = 'Get started',
  ctaType = 'NONE',
  ctaUrl = '#',
  headline = null,
  id = 'NO_ID_PROVIDED',
  subHeadline = null,
  themeName = 'light',
}) => {
  let CTA = ctasMap[ctaType]

  useEffect(() => {
    if (ctaType && !CTA) {
      CTA = ctasMap[ctaType]
    }
  }, [ctaType, CTA])

  return (
    <Module
      backgroundImage={backgroundImage}
      backgroundSize="auto"
      id={id}
      style={{
        alignContent: 'center',
        flexWrap: 'wrap',
        padding: '12rem 2rem 8rem',
      }}
      theme={themesMap[themeName]}
    >
      <Container>
        <Row>
          {headline && <ModuleHeadline>{headline}</ModuleHeadline>}
          {subHeadline && <ModuleSubheadline>{subHeadline}</ModuleSubheadline>}
        </Row>
        <Row>{CTA && <CTA text={ctaText} url={ctaUrl} />}</Row>
      </Container>
    </Module>
  )
}

export default CenterModule
